import { getSessionEmail, normalizeEmail } from "@/lib/userSession";

const getClerkPrimaryEmail = () => {
  if (typeof window === "undefined") return null;
  try {
    const clerkEmail =
      window.Clerk?.user?.primaryEmailAddress?.emailAddress ||
      window.Clerk?.session?.user?.primaryEmailAddress?.emailAddress ||
      window.Clerk?.session?.user?.emailAddresses?.[0]?.emailAddress ||
      null;
    return normalizeEmail(clerkEmail || "");
  } catch {
    return null;
  }
};

export const getResolvedDashboardEmail = ({ dashboardContextEmail = "" } = {}) => {
  return (
    normalizeEmail(getSessionEmail() || "") ||
    getClerkPrimaryEmail() ||
    normalizeEmail(dashboardContextEmail || "") ||
    ""
  );
};

export const getDashboardIdentityEmail = getResolvedDashboardEmail;
